export const WooCommerceSettingsTab = {
    WOO_COMMERCE: 0,
}